import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';

export class BlockDayNotificationModal extends React.Component {
  componentDidMount () {
    const { bookingId = '', reason = '' } = this.props;
    analyticsIntegrations.declineConfirmation(bookingId, reason);
  }

  render () {
    const { onClose, schedule = [], spaceId = '', syncConnected = false } = this.props;
    const { startDateTime, endDateTime } = schedule[0] || {};
    return (
      <BootstrapModal
        onClose={onClose}
        modalClass="block-day-notification-modal"
        showModal
        banner={{
          type: 'success',
          text:
            <ul className="list-inline">
              <li className="v-center"><i className="ico ico-lg icon-yes" /></li>
              <li className="v-center">
                <FormattedMessage
                  id="inbox.block_day_notification_modal.declined_request"
                  defaultMessage="You have declined the booking request"
                />
              </li>
            </ul>
        }}
        header={
          <div>
            <h3>
              <FormattedMessage
                id="inbox.block_day_notification_modal.update_calendar"
                defaultMessage="Update your calendar"
              />
            </h3>
            <p>
              {
                syncConnected
                  ? <FormattedMessage
                    id="inbox.block_day_notification_modal.block_time_calendar"
                    defaultMessage="Block this time on your calendar to let future guests know it’s not available. Keeping an accurate calendar will improve your visibility in search and help you get more bookings."
                  />
                  : <FormattedMessage
                    id="inbox.block_day_notification_modal.sync_calendar"
                    defaultMessage="Sync an external calendar or block unavailable times to show future guests what times are available. Keeping an accurate calendar will improve your visibility in search and help you get more bookings."
                  />

              }
            </p>
          </div>
        }
        body={
          <div className="text-center form-modal">
            {
              syncConnected ?
                <div>
                  <div className="h3">{startDateTime.format('MMMM D')}</div>
                  <div className="h3">{`${startDateTime.format('h:mm a')} - ${endDateTime.format('h:mm a')}`}</div>
                  {
                    1 < schedule.length ?
                      <p className="text-gray-dark">
                        <FormattedMessage
                          id="inbox.block_day_notification_modal.requested_days"
                          defaultMessage="+{days} more requested days"
                          values={{
                            days: schedule.length - 1
                          }}
                        />
                      </p> : null
                  }
                  <div style={{ marginTop: '60px' }}>
                    <div>
                      <a href={`/calendar/${spaceId}#a=block-day&source=decl`} className="btn btn-block btn-primary classic">
                        <FormattedMessage
                          id="inbox.block_day_notification_modal.block_time"
                          defaultMessage="Block Time"
                        />
                      </a>
                    </div>
                    <div className="text-primary" style={{ marginTop: '18px' }}>
                      <a href={`/calendar/${spaceId}/settings`} className="btn btn-block btn-primary btn-outline classic">
                        <FormattedMessage
                          id="inbox.block_day_notification_modal.sync_settings"
                          defaultMessage="View Sync Settings"
                        />
                      </a>
                    </div>
                  </div>
                </div> :
                <div>
                  <div style={{ marginTop: '60px' }}>
                    <div className="text-primary">
                      <a href={`/calendar/${spaceId}/settings`} className="btn btn-block btn-primary classic">
                        <FormattedMessage
                          id="inbox.block_day_notification_modal.sync_external"
                          defaultMessage="Sync External Calendar"
                        />
                      </a>
                    </div>
                    <div className="text-primary" style={{ marginTop: '18px' }}>
                      <a href={`/calendar/${spaceId}#a=block-day&source=decl`} className="btn btn-block btn-primary btn-outline classic">
                        <FormattedMessage
                          id="inbox.block_day_notification_modal.block"
                          defaultMessage="Block Time"
                        />
                      </a>
                    </div>
                  </div>
                </div>
            }
          </div>
        }
        modalSize="sm-size"
      />
    );
  }
}

BlockDayNotificationModal.propTypes = {
  onClose: PropTypes.func,
  schedule: PropTypes.array,
  bookingId: PropTypes.string,
  reason: PropTypes.string,
  spaceId: PropTypes.string,
  syncConnected: PropTypes.bool
};
